import { h } from 'preact';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import Image from 'utils/image';
import clsx from 'clsx';
import ArrowLeft from '../utils/icon/arrow-left.svg';
import ArrowRight from '../utils/icon/arrow-right.svg';
import Badges from './product-badges';

SwiperCore.use([Pagination]);

const pagination = {
  el: '.custom-pagination',
  clickable: true,
  type: 'bullets',
  bulletClass: 'bullet',
  bulletActiveClass: 'bullet-active',
};

const ProductGallery = ({ currentProduct, customClass }) => {
  const badgesData = JSON.parse(
    document.querySelector('[data-badges]').textContent,
  );
  return (
    <div
      className={clsx('relative laptop:sticky laptop:top-[105px]', customClass)}
    >
      <Swiper
        loop={true}
        slidesPerView={1.15}
        spaceBetween={10}
        modules={[Navigation, Pagination]}
        navigation={{
          nextEl: '.swiper-button-next-gallery',
          prevEl: '.swiper-button-prev-gallery',
        }}
        pagination={pagination}
        breakpoints={{
          1024: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        }}
      >
        {currentProduct?.images?.edges?.map((media, index) => (
          <SwiperSlide key={media.node.id}>
            <div
              className={clsx(
                'pt-[84%] !h-0 relative block',
                media.node.src.includes('white-background') && 'bg-[#F1EEE7]',
              )}
            >
              {index === 0 && (
                <Badges
                  currentProduct={currentProduct}
                  oosBadge={
                    currentProduct?.availableForSale
                      ? false
                      : badgesData.badges[0]?.standard_badge?.find(
                          (b) => b.name === 'oos',
                        )
                  }
                />
              )}
              <Image
                {...media.node}
                srcWidths={{
                  sm: 640,
                  md: 768,
                  lg: 1024,
                  xl: 1280,
                  '2xl': 1536,
                }}
                classes={clsx(
                  'block w-full absolute top-0 left-0 h-full object-cover',
                  media.node.src.includes('white-background') &&
                    'mix-blend-multiply',
                )}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div
        className={clsx(
          'item-center justify-between absolute w-[calc(100%-115px)] left-10 bottom-5 z-[1] hidden',
          currentProduct?.images?.edges?.length > 1 && 'laptop:flex',
        )}
      >
        <button className="swiper-button-prev-gallery navigation-arrow">
          <ArrowLeft />
        </button>
        <div className="custom-pagination z-[1] !w-auto flex items-center gap-4 relative top-[5px]" />
        <button className="swiper-button-next-gallery navigation-arrow">
          <ArrowRight />
        </button>
      </div>
    </div>
  );
};

export default ProductGallery;
